const SERVER_URL = "https://nitj.ac.in/api";
// const SERVER_URL = "http://localhost:8000/api"
const departments = {
  it: "Information Technology",
  cse: "Computer Science and Engineering",
  bt: "Bio Technology",
  ce: "Civil Engineering",
  ch: "Chemical Engineering",
  ece: "Electronics and Communication Engineering",
  ee: "Electrical Engineering",
  ice: "Instrumentation and Control Engineering",
  me: "Mechanical Engineering",
  ipe: "Industrial and Production Engineering",
  ma: "Mathematics and Computing",
  ph: "Physics",
  tt: "Textile Technology",
  hm: "Humanities and Management",
  cy: "Chemistry",
  cee: "Center for Energy and Environment",
  cw: "Central Workshop",
  cai: "Center for Artificial Intelligence",
  sdc: "Skill Development Centre",
  itep: "Integrated Teacher Education Programme (ITEP)",
};
module.exports = { SERVER_URL, departments };
